export const changeTeamClassificationApiConfig = ({ id, value }) => ({
    url: `/api/membership/${id}/`,
    method: 'PATCH',
    data: {
        internal_teams: value,
    },
});

export const getTeamClassificationApiConfig = () => ({
    url: '/api/tags?type=membership',
    method: 'GET',
});

export const roleChangeApiConfig = ({ id, role }) => ({
    url: `/api/membership/${id}/`,
    method: 'PATCH',
    data: {
        role,
    },
});

export const sendInviteApiConfig = ({ inviteRole, inviteEmail }) => ({
    url: '/api/invites/',
    method: 'POST',
    data: {
        role: inviteRole,
        email: inviteEmail,
    },
});

export const getTeamMembersApiConfig = () => ({
    url: '/api/team/',
    method: 'GET',
});

export const getInvitesApiConfig = () => ({
    url: '/api/invites/?status=sent',
    method: 'GET',
});

export const deleteInviteApiConfig = ({ itemId }) => ({
    url: `/api/invites/${itemId}/delete`,
    method: 'DELETE',
});

export const deleteUserApiConfig = ({ userId }) => ({
    url: `/api/membership/${userId}/`,
    method: 'DELETE',
});
